<template>
  <span class="block leading-snug" v-if="text != null">{{ text }}</span>
</template>

<script>
import { mapGetters } from "vuex";

/**
 * @see https://docs.google.com/document/d/1qOCUGjx8xvIx0UMAo6AxAe1PBN8q5qPVaQcuuFeiOOA/
 */
export default {
  name: "ListPlace",
  props: {
    listPlace: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      text: null
    };
  },
  created() {
    const listNumber = this.listNumber;
    const position = this.listPlace.position;
    const placeNumber = this.listPlace.number;
    if (listNumber > 0) {
      if (position > 0) {
        if (placeNumber != null) {
          // listNumber, position & placeNumber are known
          this.text = this.$t(
            "components.candidate.list_place.list_with_full_list_place",
            {
              list: listNumber,
              position: position,
              number: placeNumber
            }
          );
        } else {
          // listNumber and position are known
          this.text = this.$t(
            "components.candidate.list_place.list_with_position",
            {
              list: listNumber,
              position: position
            }
          );
        }
      } else {
        if (placeNumber != null) {
          // listNumber and placeNumber are known
          this.text = this.$t(
            "components.candidate.list_place.list_with_number_text",
            {
              list: listNumber,
              number: placeNumber
            }
          );
        } else {
          // only list number is known
          this.text = this.$t(
            "components.candidate.list_place.list_without_place",
            {
              list: listNumber
            }
          );
        }
      }
    } else {
      if (position > 0) {
        if (placeNumber != null) {
          // position and placeNumber are known
          this.text = this.$t(
            "components.candidate.list_place.full_list_place",
            {
              position: position,
              number: placeNumber
            }
          );
        } else {
          // only position is known
          this.text = this.$t("components.candidate.list_place.list_position", {
            position: position
          });
        }
      } else {
        if (placeNumber != null) {
          // only place number is known
          this.text = this.$t(
            "components.candidate.list_place.list_number_text",
            {
              position: position,
              number: placeNumber
            }
          );
        } else {
          this.text = null;
        }
      }
    }
  },
  computed: {
    ...mapGetters("list", { getList: "list" }),
    list() {
      return this.listPlace.listId > 0
        ? this.getList(this.listPlace.listId) || null
        : null;
    },
    listNumber() {
      const list = this.list;
      return list != null ? list.number : null;
    }
  }
};
</script>

<style scoped></style>
